import { getStateColors } from './icon_helpers';

/**
 * Creates a access entry - access point gate icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createAccessPointGateIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- access entry - access point gate icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="3" y="4" width="2" height="16" /><rect fill="${colors.iconColor}" x="19" y="4" width="2" height="16" /><rect fill="${colors.iconColor}" x="7" y="6" width="5" height="12" /><rect fill="${colors.iconColor}" x="12" y="6" width="5" height="12" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="15" cy="12" r="1" /><path fill="${colors.iconColor}" d="M7 9h5M12 9h5M7 11h5M12 11h5M7 13h5M12 13h5M7 15h5M12 15h5" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a access entry - entry point icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createEntryPointIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- access entry - entry point icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M4 5v15h7v-6h2v6h7V5z" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="2" x="7" y="8" width="3" height="3" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="2" x="7" y="13" width="3" height="3" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="2" x="14" y="8" width="3" height="3" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="1.5" x="11" y="16" width="2" height="4" /><path fill="${colors.iconColor}" d="M12 2l8 3v2l-8-3-8 3V5z" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a access entry - loading bay icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createLoadingBayIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- access entry - loading bay icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="2" y="9" width="12" height="9" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="2" x="4" y="11" width="3" height="3" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="2" x="9" y="11" width="3" height="3" /><path fill="${colors.iconColor}" d="M14 13h4l2 2v3h-6z" /><circle fill="${colors.iconColor}" cx="6" cy="18" r="2" /><circle fill="${colors.iconColor}" cx="19" cy="18" r="2" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="6" cy="18" r="0.8" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="1.5" cx="19" cy="18" r="0.8" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a access entry - no go zone icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createNoGoZoneIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- access entry - no go zone icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="none" stroke="${colors.iconColor}" stroke-width="2.5" cx="12" cy="12" r="9" /><path fill="${colors.iconColor}" d="M6 6l12 12" stroke-width="3" stroke-linecap="round" /><circle fill="${colors.iconColor}" cx="10" cy="9" r="1.5" /><path fill="${colors.iconColor}" d="M9 11l-1 3 1.5 1 .5 4h1.5v-4l1.5-1 .5-3z" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a access entry - visitor check in point icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createVisitorCheckInPointIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- access entry - visitor check in point icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="6" y="3" width="12" height="18" rx="1" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="2" cx="12" cy="9" r="2.5" /><path fill="${colors.iconColor}" d="M8 15c0-2 1.5-3 4-3s4 1 4 3" /><rect fill="${colors.iconColor}" x="8" y="17" width="8" height="1" /><rect fill="${colors.iconColor}" x="8" y="19" width="8" height="1" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const accessentryIcons = {
  access_point_gate: createAccessPointGateIcon,
  entry_point: createEntryPointIcon,
  loading_bay: createLoadingBayIcon,
  no_go_zone: createNoGoZoneIcon,
  visitor_check_in_point: createVisitorCheckInPointIcon
};
